import { isElectron } from '@/utils/electron'

export function getScrollTop() {
  return window.pageYOffset !== undefined
    ? window.pageYOffset
    : document.documentElement.scrollTop
}

export function getWindowHeight() {
  return document.documentElement.clientHeight
}

export function getElementScrollRemaining(element: HTMLElement) {
  return element.scrollHeight - element.offsetHeight - element.scrollTop
}

export async function minimize() {
  if (!isElectron()) {
    console.log('Not support minimizing in non-electron mode')
  } else {
    await window.ipcRenderer.send('minimize-window')
  }
}

export async function quit() {
  if (!isElectron()) {
    console.log('Not support closing window in non-electron mode')
  } else {
    await window.ipcRenderer.send('quit')
  }
}
